import React from 'react'

/**
 * AbwaabPlus RingChart — circular SVG progress ring with a centered % label.
 * The canonical overall-completion / performance visual. Stroke = 10% of
 * diameter, round caps, starts at 12 o'clock (−90°), fills clockwise.
 */
export interface AbwRingChartProps {
	value?: number
	size?: number
	color?: string
	caption?: React.ReactNode
	style?: React.CSSProperties
}

export function RingChart({ value = 0, size = 120, color = 'var(--blue)', caption, style }: AbwRingChartProps) {
	const stroke = size * 0.1
	const r = (size - stroke) / 2
	const circ = 2 * Math.PI * r
	const offset = circ * (1 - Math.min(value / 100, 1))
	const labelSize = size >= 100 ? 20 : 16
	return (
		<div style={{ position: 'relative', width: size, height: size, flex: 'none', ...style }}>
			<svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
				<circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--border)" strokeWidth={stroke} />
				<circle
					cx={size / 2}
					cy={size / 2}
					r={r}
					fill="none"
					stroke={color}
					strokeWidth={stroke}
					strokeLinecap="round"
					strokeDasharray={circ}
					strokeDashoffset={offset}
					style={{ transition: 'stroke-dashoffset var(--dur-fill) var(--ease)' }}
				/>
			</svg>
			<div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
				<span dir="ltr" style={{ font: `var(--fw-bold) ${labelSize}px var(--font-sans)`, color }}>
					{Math.round(value)}%
				</span>
				{caption && <span style={{ font: 'var(--text-meta)', color: 'var(--text-secondary)' }}>{caption}</span>}
			</div>
		</div>
	)
}
